import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useErrMsg = () => {
  const { t } = useTranslation();
  return useMemo(
    () => (errCode) => {
      switch (errCode) {
        case 4500:
          return t("Invalid parameters");
        case 4501:
        case 4502:
        case 4503:
          return t("Unauthorized");
        case 4504:
          return t("Session Expired");
        case 4505:
          return t("Component not found");
        case 4506:
          return t("Component file not found");
        case 4507:
          return t("Permission denied");
        case 4508:
          return t("Invalid license key");
        case 4509:
          return t("Trial license not accepted");
        case 4510:
          return t("Moxa license not accepted");
        case 4511:
          return t("License has expired");
        case 4512:
          return t("License not start yet");
        default:
          return t("Unknown error");
      }
    },
    [t]
  );
};
